import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { Member, Credit, Print } from "../../service/member/member";
import { CommonService } from "../../service/common/common.service";
import { AuthService } from "../../service/auth/auth.service";
import { PageService } from "../../service/page/page.service";
import { PageMypageLink } from "../../service/page/page";
import { ShareService } from "app/service/share/share.service";
import { MemberService } from "app/service/member/member.service";

@Component({
  selector: "app-myinfo",
  templateUrl: "./myinfo.component.html",
  styleUrls: ["./myinfo.component.scss"],
  providers: [ShareService, PageService, MemberService],
})
export class MyinfoComponent implements OnInit {
  @Output() sendMessage = new EventEmitter<any>();

  me: Member;
  credit: Credit;
  print: Print;
  links: PageMypageLink[] = [];

  myinfoSubscription;

  constructor(
    private shareService: ShareService,
    private pageService: PageService,
    private commonService: CommonService,
    private authService: AuthService,
    private memberService: MemberService,
    private router: Router
  ) {
    this.getMe();
    this.myinfoSubscription = this.commonService.myinfoEvent.subscribe((res) =>
      this.getMe()
    );

    this.pageService.getMypageLink().subscribe((links) => (this.links = links));
  }

  getMe() {
    this.shareService.awaitMe().subscribe((me) => {
      this.me = me;
      // 특정 계정 이동문제
      // if (!this.me.name || !this.me.nick) this.router.navigateByUrl('/member/myinfo-edit');
    });

    this.shareService
      .awaitCredit()
      .subscribe((credit) => (this.credit = credit));

    this.shareService.awaitPrint().subscribe((print) => (this.print = print));
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.myinfoSubscription.unsubscribe();
  }

  onEdit() {
    this.router.navigateByUrl("/member/myinfo-edit");
  }

  hasManager() {
    return this.authService.hasManager();
  }

  isShowPrintTip: boolean = false;

  // 모두의 주차장 (서울숲만)
  isSeoulsoop() {
    if (this.me) {
      return this.me.location.key === "seoulsoop";
    }

    return false;
  }

  async handleModu(evt) {
    evt.preventDefault();
    const policy = await this.memberService.getPolicy();

    if (!policy.thirdParty) {
      alert(
        "개인정보 제3자 제공에 동의한 멤버에 한하여 본 서비스 이용이 가능합니다."
      );
      this.commonService.openThirdPartyModal();
    } else {
      try {
        const isApp =
          window.navigator.userAgent.indexOf("hey_application") > -1;
        let {
          authorizationUrl,
        } = await this.memberService.getModuURL().toPromise();

        if (isApp) {
          authorizationUrl += `&callbackUrl=${location.href}`;
          location.href = authorizationUrl;
        } else {
          window.open(authorizationUrl, "_blank").focus();
        }
      } catch (error) {
        alert("관리자에게 문의 바랍니다.");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/myinfo/myinfo.component.ts